import { koComponent } from '../../ko-utils';
import * as siteConfig from '../../site-config/config';

class IconSizingValue {
    constructor(params) {
        this.root = params.rootElement;
        this.onChange = params.onChange;
        this.allowSpacing = params.allowSpacing;

        this.sizingOptions = [
            { text: 'Small', value: 'small' },
            { text: 'Regular' },
            { text: 'Large', value: 'large' },
        ];

        if (!this.root()) {
            this.root(new siteConfig.IconSizingValue());
        }

        if (this.onChange) {
            const subscribeAndNotify = (prop) => {
                if (this.root() && this.root()[prop]) {
                    this.root()[prop].subscribe((val) => {
                        this.onChange(prop);
                    });
                }
            };

            subscribeAndNotify('spacing');
            subscribeAndNotify('size');
        }
    }
}

export default koComponent('icon-sizing-value', IconSizingValue);